import { TabView, TabPanel } from "primereact/tabview";
import { SectionHeader } from "../../components/SectionHeader/SectionHeader";
import { FloorSurfaces } from "./tabs/FloorSurfaces";
import { ProjectTypes } from "./tabs/ProjectTypes";
import { Supplies } from "./tabs/Supplies";
import { DenyReasonTypes } from "./tabs/DenyResonTypes";
import { PaperProducts } from "./tabs/PaperProducts";
import { PrivateAccess } from "../../keycloak";
import { UserRoles } from "../../constants/userRoles";

export const Administration = () => {
  return (
    <div>
      <SectionHeader title="Leads Form" />
      <div className="card">
        <TabView>
          <TabPanel header="Project types and SoW">
            <PrivateAccess
              roles={{
                dcs_client: [UserRoles.PROJECT_TYPE_VIEW],
              }}
            >
              <ProjectTypes />
            </PrivateAccess>
          </TabPanel>
          <TabPanel header="Floor Surface types">
            <PrivateAccess
              roles={{
                dcs_client: [UserRoles.TYPE_OF_FLOOR_SURFACES_VIEW],
              }}
            >
              <FloorSurfaces />
            </PrivateAccess>
          </TabPanel>
          <TabPanel header="Supplies">
            <PrivateAccess
              roles={{
                dcs_client: [UserRoles.SUPPLIES_VIEW],
              }}
            >
              <Supplies />
            </PrivateAccess>
          </TabPanel>
          <TabPanel header="Paper products">
            <PrivateAccess
              roles={{
                dcs_client: [UserRoles.PAPER_PRODUCTS_VIEW],
              }}
            >
              <PaperProducts />
            </PrivateAccess>
          </TabPanel>
          <TabPanel header="Deny reason types">
            <PrivateAccess
              roles={{
                dcs_client: [UserRoles.DENIED_REASON_TYPE_VIEW],
              }}
            >
              <DenyReasonTypes />
            </PrivateAccess>
          </TabPanel>
        </TabView>
      </div>
    </div>
  );
};
